import {Card, CardActionArea, CardMedia, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {downloadImage} from "../../helpers/utils";
import React, {useEffect, useMemo, useState} from "react";

import {parseValue} from "../../hooks";

import {useFetch} from "../../helpers/hooks";
import {Endpoint} from "../../constants/enums";

import {LinkOutlined, PlaceOutlined} from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 500,
    height: 'auto'
  },
  media: {
    width: '100%',
    backgroundPosition: 'top'
  },
});

const ExhibitMedia = (props) => {

  const classes = useStyles();

  const {image,result} = props

  const [thumbnail, setThumbnail] = useState(null)
  const [coverImage,setCoverImage] = useState(thumbnail)
  const [flipped,setFlipped] = useState(null)

  useEffect(()=>{
    if (thumbnail)
      setCoverImage(thumbnail)
  },[thumbnail])

  const toggleImage = () =>{
    if (flipped)
      if (coverImage === thumbnail)
        setCoverImage(flipped)
      else setCoverImage(thumbnail)
    return true
  }

  const description = useMemo(() => {
    if (!result) return
    return parseValue('property:description', result?.properties)
  }, [result])

  const longDescription = useMemo(()=>{
    if (!result) return
    return parseValue('paragraph',result?.properties)
  },[result])

  const place = useMemo(() => {
    if (!result) return
    return parseValue('property:place', result?.properties)
  }, [result])

  const source = useMemo(() => {
    if (!result) return
    return parseValue('property:url', result?.properties)
  }, [result])

  useMemo(() => {
    const mainImage = image
    downloadImage(mainImage?.uuid, setThumbnail)
  }, [result])

  return <img
        className={classes.media}
        src={coverImage}
        title={image.label}
      />
}

export default ExhibitMedia